import moment, * as Moment from 'moment-timezone';
import { FunctionComponent, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useInterval } from '../hooks/useInterval';

type Props = {
  expires: Moment.Moment | null;
  onExpiry: () => void;
};

const ExpirationTimer: FunctionComponent<Props> = ({ expires, onExpiry }) => {
  const [countDown, setCountDown] = useState('-');
  const [hasExpired, setHasExpired] = useState(false);
  const { t } = useTranslation();

  useInterval(() => {
    // Calculate minute difference between now and expires
    if (expires) {
      const expDiff = expires.valueOf() - moment().valueOf();
      if (expDiff >= 0) {
        const minutes = Math.floor((expDiff % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((expDiff % (1000 * 60)) / 1000);

        const secStr = seconds < 10 ? `0${seconds}` : seconds.toString();
        const minStr = minutes < 10 ? `0${minutes}` : minutes.toString();

        setCountDown(`${minStr}:${secStr}`);
        return;
      }
    }
    setHasExpired(true);
  }, hasExpired);

  useEffect(() => {
    if (hasExpired) {
      setCountDown(t('components.expirationTimer.reservationHasExpired'));
      onExpiry();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [hasExpired]);

  return <div className="et-countdown">{countDown}</div>;
};

export default ExpirationTimer;
